import { render } from "./PricingCard.vue?vue&type=template&id=57308cc8&ts=true"
import script from "./PricingCard.vue?vue&type=script&lang=ts"
export * from "./PricingCard.vue?vue&type=script&lang=ts"

import "./PricingCard.vue?vue&type=style&index=0&id=57308cc8&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__